import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-folder-open mt-1" }, null, -1)
const _hoisted_2 = { class: "d-none d-md-block ms-2" }

import { blocklyStore } from "../../../blockly/blocklyStore";
import { translation } from '../../../lang/Translation';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'AssetsButton',
  setup(__props) {

const router = useRouter();
const showAssets = () => {
  const project_id = blocklyStore.project_id;

  router.push({name:"FileManagerPage", params: {"project_id":project_id},query:{"page":"user"}});

};
const t = translation;
const buttonName = t.to("マイアセット","my_assets")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "d-flex me-2 btn-outline-secondary btn btn-lg",
    onClick: showAssets
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(buttonName)), 1)
  ]))
}
}

})